import { flow, types } from "mobx-state-tree";
import { ErrorModel } from "../../components/common/error";
import orgAPI from "../org/OrgService";
import { SelectListModel } from "../share";
import systemHelperAPI from "./SystemHelperService";
import { ISelectListModel } from "../share/SelectListModel";

export const SelectListGroupModel = types
    .model("SelectListGroupModel", {
        list: types.optional(types.array(SelectListModel), []),
        error: types.optional(ErrorModel, {}),
    })
    .views((self: any) => ({
        //
    }))
    .actions((self: any) => ({
        getProjectTypeLabel(code: string) {
            const selected = self.list;
            const selectedItem = selected
                ? selected.find((item: ISelectListModel) => item.code === code)
                : undefined;
            return selectedItem ? selectedItem.description : "-";
        },
        getOrgAffiliates: flow(function*() {
            try {
                const result = yield orgAPI.getOrgAffiliates();
                self.list = result.data;
                self.error.tigger = false;
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                //
            }
        }),
        getProjectTypeByOrg: flow(function*(orgId: number, source?: string | null) {
            try {
                const result = yield systemHelperAPI.getProjectTypeByOrg(orgId, source);
                self.list = result.data;
                self.error.tigger = false;
            } catch (e) {
                self.error.tigger = true;
                self.error.code = e.code;
                self.error.title = e.name;
                self.error.message = e.message;
                self.error.technicalStack = e.technicalStack;
                throw e;
            } finally {
                //
            }
        }),
    }));
export type ISelectListGroupModel = typeof SelectListGroupModel.Type;
